import type { RouteRead } from '@/types';

const ROUTE_COLORS: Record<string, string> = {
  Red: '#DA291C',
  Mattapan: '#DA291C',
  Orange: '#ED8B00',
  Blue: '#003DA5',
  'Green-B': '#00843D',
  'Green-C': '#00843D',
  'Green-D': '#00843D',
  'Green-E': '#00843D',
};

const COMMUTER_RAIL_COLOR = '#80276C';
const SILVER_LINE_COLOR = '#7C878E';
const FALLBACK_COLOR = '#6B7280';

function ensureHash(hex: string): string {
  return hex.startsWith('#') ? hex : `#${hex}`;
}

type RouteColorInput = string | Pick<RouteRead, 'id' | 'color'> | null | undefined;

export function routeColor(input: RouteColorInput): string {
  if (!input) return FALLBACK_COLOR;
  if (typeof input === 'string') {
    if (ROUTE_COLORS[input]) return ROUTE_COLORS[input];
    if (input.startsWith('CR-')) return COMMUTER_RAIL_COLOR;
    if (input.startsWith('Green-')) return ROUTE_COLORS['Green-B'] ?? FALLBACK_COLOR;
    if (input === 'Silver' || input.startsWith('7') || input.startsWith('SL')) {
      return SILVER_LINE_COLOR;
    }
    return FALLBACK_COLOR;
  }
  if (input.color) {
    return ensureHash(input.color);
  }
  return routeColor(input.id);
}
